import { queryApi } from 'lib/api';
import { Response } from 'lib/api/type';
import {
  ItemDetailResponse,
  ItemIdListParam,
  ItemIdParam,
  ItemListParam,
  ItemListResponse,
} from './type';

export const getItemList = (data: ItemListParam): Promise<ItemListResponse> =>
  queryApi('mint/item/list', data);

export const setItemDrop = (data: ItemIdListParam): Promise<Response> =>
  queryApi('mint/item/drop', data);

export const getItemDetail = (data: ItemIdParam): Promise<ItemDetailResponse> =>
  queryApi('mint/item/get', data);

export const setItemCancel = (data: ItemIdParam): Promise<Response> =>
  queryApi('mint/item/cancel', data);
